// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3602) return "notification.app-chunk.min.js?v=1747901686207";
	if (chunkId === 2917) return "sticky-cart-new-4-0-13.app-chunk.min.js?v=1747901686207";
	if (chunkId === 8075) return "wishlist-new-4-0-3.app-chunk.min.js?v=1747901686207";
	if (chunkId === 8974) return "8974.app-chunk.min.js?v=1747901686207";
	if (chunkId === 4026) return "new-customer-pop.app-chunk.min.js?v=1747901686207";
	if (chunkId === 9964) return "membership-packet.app-chunk.min.js?v=1747901686207";
	// return url for filenames based on template
	return undefined;
};